var exports = {
  "e6": "ChannelItem.module__channelItemCore___RUdBc1",
  "$H": "ChannelItem.module__channelItemCoreSelected___RUdBc1",
  "_B": "ChannelItem.module__channelItemCoreUnselected___RUdBc1",
  "Vp": "ChannelItem.module__channelItemCoreHovered___RUdBc1",
  "TV": "ChannelItem.module__typingTooltip___RUdBc1",
  "kp": "ChannelItem.module__channelTypingIndicator___RUdBc1",
  "IM": "ChannelItem.module__typingIndicatorIcon___RUdBc1",
  "U4": "ChannelItem.module__channelItemSelected___RUdBc1",
  "OI": "ChannelItem.module__typingAvatars___RUdBc1",
  "_N": "ChannelItem.module__channelItemIcon___RUdBc1",
  "Jz": "ChannelItem.module__channelItemIconSelected___RUdBc1",
  "Wk": "ChannelItem.module__categoryContainer___RUdBc1",
  "yb": "ChannelItem.module__categoryName___RUdBc1",
  "zc": "ChannelItem.module__iconContainer___RUdBc1",
  "HA": "ChannelItem.module__channelName___RUdBc1",
  "Hq": "ChannelItem.module__actionsContainer___RUdBc1",
  "OO": "ChannelItem.module__channelItemIconUnselected___RUdBc1",
  "Cr": "ChannelItem.module__channelItemIconHighlight___RUdBc1",
  "rC": "ChannelItem.module__channelItemLabel___RUdBc1",
  "gw": "ChannelItem.module__channelItemActions___RUdBc1",
  "kL": "ChannelItem.module__container___RUdBc1",
  "YI": "ChannelItem.module__channelReorderTarget___RUdBc1",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___RUdBc1",
  "XE": "ChannelItem.module__unreadIndicator___RUdBc1",
  "_j": "ChannelItem.module__unreadIndicatorMuted___RUdBc1",
  "fc": "ChannelItem.module__channelItem___RUdBc1",
  "Z$": "ChannelItem.module__channelItemCategory___RUdBc1",
  "RQ": "ChannelItem.module__channelItemRegular___RUdBc1",
  "zx": "ChannelItem.module__channelItemHighlight___RUdBc1",
  "_R": "ChannelItem.module__channelItemMuted___RUdBc1",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___RUdBc1",
  "Fb": "ChannelItem.module__channelItemHoverable___RUdBc1",
  "FN": "ChannelItem.module__channelItemPressed___RUdBc1",
  "Je": "ChannelItem.module__channelItemOver___RUdBc1",
  "X9": "ChannelItem.module__channelItemContextMenu___RUdBc1",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___RUdBc1",
  "GJ": "ChannelItem.module__channelItemDragging___RUdBc1",
  "rO": "ChannelItem.module__channelItemDimmed___RUdBc1",
  "x1": "ChannelItem.module__channelItemMutedState___RUdBc1",
  "Ef": "ChannelItem.module__hoverAffordance___RUdBc1",
  "Mn": "ChannelItem.module__keyboardFocus___RUdBc1",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___RUdBc1",
  "Yq": "ChannelItem.module__categoryContent___RUdBc1",
  "Yl": "ChannelItem.module__categoryIcon___RUdBc1",
  "Sk": "ChannelItem.module__createChannelButton___RUdBc1",
  "$Z": "ChannelItem.module__createChannelIcon___RUdBc1",
  "Ne": "ChannelItem.module__voiceUserCount___RUdBc1",
  "p9": "ChannelItem.module__channelItemVoice___RUdBc1",
  "pL": "ChannelItem.module__contextMenuOpen___RUdBc1",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___RUdBc1",
};

module.exports = exports;
